export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.MODE === "production"
    ? "https://prod.sync-cal.com" // Production fallback
    : "http://localhost:3001"); // Development fallback

export const FRONTEND_BASE_URL =
  import.meta.env.VITE_FRONTEND_BASE_URL ||
  (import.meta.env.MODE === "production"
    ? "https://app.sync-cal.com" // Production fallback
    : "http://localhost:5173"); // Development fallback

export const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  "396128879430-0dvq48doitr903uerpo5el9niab23gqg.apps.googleusercontent.com";

export const MICROSOFT_CLIENT_ID =
  import.meta.env.MODE === "production"
    ? "6e902734-b650-421d-a2bd-43f6b9133a9f"
    : "6e902734-b650-421d-a2bd-43f6b9133a9f";
export const MICROSOFT_CLIENT_SECRET =
  import.meta.env.MODE === "production"
    ? "p_e8Q~yAFzhcHXHze6QDEdTe9VT4vg4hPx5tPdt3"
    : "TBD";
export const MICROSOFT_REDIRECT_URI =
  import.meta.env.MODE === "production"
    ? "https://prod.sync-cal.com/calendar/microsoft" // new endpoint instead of /calendar?provider=microsoft
    : "http://localhost:3001/calendar/microsoft";  // new endpoint instead of /calendar?provider=microsoft
export const ENABLE_OUTLOOK_CALENDAR = "true";

export const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID || "TODO";
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
